import { searchQueryMaxLength } from '../../config/results';

export default {
  name: 'SearchKeyword',
  props: {
    keywordLabel: {
      type: String,
      required: true,
      default: 'Keyword',
    },
    selectedKeyword: {
      type: String,
      default: '',
    },
    searchQueryMaxLength: {
      default: () => searchQueryMaxLength,
      type: [Number, String],
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      internalKeyword: this.selectedKeyword,
    };
  },
};
